import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import styled, { useTheme } from 'styled-components';
import LegendItem from './components/LegendItem';
import CanvasJSChart from '../../assets/CanvasJSChart';

const LegendItemStyle = styled(LegendItem)`
  ${(props) => props?.graphTheme?.baseFontStyle}
`;

const Chart = ({ className, legendItems, options = {} }) => {
  const theme = useTheme();

  const activeAndGraphTheme = {
    active: true,
    graphTheme: theme?.graph,
  };

  return (
    <div className={className}>
      <CanvasJSChart options={options} />
      <Grid
        container
        direction={'row'}
        justify={'space-evenly'}
        alignItems={'center'}
        style={{
          marginTop: 5,
        }}>
        {legendItems?.map((item, index) => (
          <LegendItemStyle {...activeAndGraphTheme} color={item.color} label={item.name} key={index} />
        ))}
      </Grid>
    </div>
  );
};

Chart.propTypes = {
  className: PropTypes.string,
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  options: PropTypes.object,
};

export default Chart;
